__turbopack_context__.v({
  "img": "style-module-scss-module__S2BQpG__img",
  "item": "style-module-scss-module__S2BQpG__item",
  "list": "style-module-scss-module__S2BQpG__list",
  "title": "style-module-scss-module__S2BQpG__title",
  "wrapper": "style-module-scss-module__S2BQpG__wrapper",
});
